import hero from "./javascript/hero.js";
import cards from "./javascript/cards.js";
import social from "./javascript/social.js";
import scroller from "./javascript/scroller.js";
import map from "./javascript/map.js";
import suppliers from "./javascript/suppliers.js";
import { scrollToTop, initScrollFunction } from "./javascript/scrollbutton.js";
import { initPopup } from "./javascript/popup.js";
import { handleExternalLinks } from "./javascript/external-links.js";
import { categorySearch } from "./javascript/categorySearch.js";
import initHeaderScroll from "./javascript/header.js";
import { eventSearch } from "./javascript/eventSearch.js";
import initReadMore from "./javascript/readMore.js";
$ = window.jQuery;

$(() => {
    hero($(".hero__slide-switch"), $(".hero__slide-prev, .hero__slide-next, .hero__enlarge"));
    cards($(".cards__link"));
    social($(".suppliers__social"));
    scroller($(".scroller__switch"));
    map($("[data-map]"));
    suppliers($(".cards__supplier"), ":first-child");
    suppliers($(".supplier-images"));
    initScrollFunction();
    initPopup();
    $('#scrollToTopBtn').on('click', scrollToTop);
    handleExternalLinks();
    categorySearch();
	eventSearch();
	initHeaderScroll();
	initReadMore();
});
